var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout_header"},[_c('img',{staticClass:"header_title",attrs:{"src":require("../../../assets/img/header/header_title.png"),"width":"145","height":"24","alt":"大数据驾驶舱"}}),_c('avatar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }